var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessagesFillNotification = function SvgMessagesFillNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#283E4C",
    fillRule: "evenodd",
    d: "M4 20c0-8.822 8.972-16 20-16s20 7.178 20 16c0 1.956-.44 3.83-1.247 5.564a8 8 0 0 0-12.13 9.534c-1.871.527-3.867.837-5.943.892L14 44V33.868C7.796 31.03 4 25.816 4 20",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 32,
    r: 5,
    fill: "#EDBE62"
  })));
};
export { SvgMessagesFillNotification as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDIwQzQgMTEuMTc4IDEyLjk3MiA0IDI0IDRDMzUuMDI4IDQgNDQgMTEuMTc4IDQ0IDIwQzQ0IDIxLjk1NTYgNDMuNTU5MSAyMy44MzA0IDQyLjc1MjcgMjUuNTY0MkM0MS40MjM5IDI0LjU4MTIgMzkuNzc5OCAyNCAzOCAyNEMzMy41ODE3IDI0IDMwIDI3LjU4MTcgMzAgMzJDMzAgMzMuMDk4NiAzMC4yMjE1IDM0LjE0NTUgMzAuNjIyMiAzNS4wOTg1QzI4Ljc1MiAzNS42MjQ4IDI2Ljc1NTYgMzUuOTM0NiAyNC42OCAzNS45OUwxNCA0NFYzMy44NjhDNy43OTYgMzEuMDMgNCAyNS44MTYgNCAyMFoiIGZpbGw9IiMyODNFNEMiLz4KPGNpcmNsZSBjeD0iMzgiIGN5PSIzMiIgcj0iNSIgZmlsbD0iI0VEQkU2MiIvPgo8L3N2Zz4K";